/* Pure rules shared by the storefront and local contract tests. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.GosBundleCore = api;
})(typeof window === 'object' ? window : globalThis, function () {
  'use strict';
  function packItems(components, packTitle, packHandle, group) {
    if (!Array.isArray(components) || !components.length) throw new Error('Composition indisponible.');
    return components.map(item => {
      if (!Number.isSafeInteger(item.id) || item.id < 1 || !Number.isInteger(item.quantity) || item.quantity < 1 || !Number.isInteger(item.price) || item.price < 0 || item.available !== true) throw new Error('Un produit du pack est indisponible.');
      return {id:item.id,quantity:item.quantity,properties:{Pack:packTitle,_gos_pack:group,_gos_parent:packHandle}};
    });
  }
  function packTotal(components) {
    return components.reduce((sum,item)=>sum + item.price * item.quantity,0);
  }
  return {packItems,packTotal};
});
